var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.906 19.906"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31360",
    d: "M.25.25h19.406v19.406H.25z",
    stroke: "#fff",
    strokeWidth: 0.5,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31361",
    d: "M13.187 1.059h-9.7a1.622 1.622 0 00-1.62 1.617v11.32h1.617V2.676h9.7zm2.426 3.234H6.719a1.622 1.622 0 00-1.618 1.618v11.32a1.622 1.622 0 001.617 1.617h8.895a1.622 1.622 0 001.617-1.617V5.911a1.622 1.622 0 00-1.617-1.618zm0 12.938H6.719V5.911h8.895z",
    stroke: "#fff",
    strokeWidth: 0.5,
    fill: "inherit"
  })));
}

export default SvgCopy;